import {React} from 'react'

import './Navbar.css'

const Navbar = ()=>{

    return (
        <div className='nav'>
                <h1 className='site-title'>Content For Developers</h1>
                
        </div>
    )
}

export default Navbar